import React from 'react';
import PropTypes from 'prop-types';

import NavDropdown from 'components/navV2/NavDropdown';
import NavLink from 'components/navV2/NavLink';
import NavLinkColumn from 'components/navV2/NavLinkColumn';
import { getDefaultLogoutDestination } from 'util/authHelpers';
import { NAV_SECTIONS } from 'util/trackNavigationClickedHelpers';
import TextUtil from 'util/TextUtil';
import { trackNavigationClicked } from 'util/trackingHelper';

import './navAccount.less';

const NavAccount = ({ accountNavData, onLogOut, userContext }) => {
  const logoutDestination = getDefaultLogoutDestination(userContext);

  const onClick = (e, child, i, isSubMenu) => {
    e.stopPropagation();
    const eventData = {
      menu_item: TextUtil.toAllUpperCase(child.title),
      section: isSubMenu ? NAV_SECTIONS.utilitySubNav : NAV_SECTIONS.utility,
      node_level_1: 'ACCOUNT',
      // Row and column position are 1-indexed.
      row_position: isSubMenu ? i + 1 : 1,
      column_position: 1,
    };
    trackNavigationClicked(eventData);
  };

  const links = accountNavData.children.map((child, i) => (
    <NavLink
      key={i}
      href={child.path}
      variant="PrimaryNavSubLink"
      onClick={(e) => onClick(e, child, i, true)}
    >
      {child.title}
    </NavLink>
  ));

  const logoutEventData = {
    menu_item: 'LOG OUT',
    section: NAV_SECTIONS.utilitySubNav,
    node_level_1: NAV_SECTIONS.utility,
    // Row and column position are 1-indexed.
    row_position: links.length + 1, // Add one because logout has not been pushed yet.
    column_position: 1,
  };

  const handleLogOut = (e) => {
    e.preventDefault();
    onLogOut(logoutDestination);
    trackNavigationClicked(logoutEventData);
  };

  links.push(
    <NavLink key="log-out" role="button" onClick={handleLogOut} variant="PrimaryNavSubLink">
      Log Out
    </NavLink>
  );

  return (
    <NavDropdown
      label="Account"
      ariaLabel={accountNavData.title}
      className="navV2__promotionalBar--account-dropdown nav-account"
      link={{
        href: accountNavData.path,
      }}
      eventType="hover"
      menuPositionX="right"
      data-testid="nav-account-dropdown"
      onClick={(e) => onClick(e, { title: accountNavData.title }, undefined, false)}
    >
      <NavLinkColumn links={links} />
    </NavDropdown>
  );
};

NavAccount.propTypes = {
  userContext: PropTypes.shape({
    business_unit_source: PropTypes.string,
  }),
  accountNavData: PropTypes.shape({
    title: PropTypes.string,
    id: PropTypes.string,
    path: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  onLogOut: PropTypes.func.isRequired,
};

NavAccount.defaultProps = {
  accountNavData: [],
};

export default NavAccount;
